export default {
  init() {
    // JavaScript to be fired on the home page

    /* eslint-disable */

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
		
	/* eslint-disable */


		    var $grid = $('#gallery-grid').imagesLoaded( function() {
          
              // init Packery after all images have loaded
              $grid.isotope({
                itemSelector: '.grid-item',
                percentPosition: true,
                masonry: {
                  // use element for option
                  columnWidth: '.grid-sizer',
                  gutter: '.gutter-sizer'
                }
              });


              $('#gallery-nav a').click(function(){
              $('#gallery-nav .current').removeClass('current');
              $(this).addClass('current');
       
              var selector = $(this).attr('data-filter');
              $('#gallery-grid').isotope({
                  filter: selector,
                  animationOptions: {
                      duration: 750,
                      easing: 'linear',
                      queue: false
                  }
               });
               return false;
              }); 

        });


        // height matching elements
        $(document).ready(function(){
            $('#gallery-grid .grid-item .card').matchHeight({byRow:false});
        });
        $(window).resize(function() {
            $('#gallery-grid .grid-item .card').matchHeight({byRow:false});
        });

        



    /* eslint-enable */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/gradegroup.js